import React from 'react';
import { Card, Skeleton } from 'antd';
import { SkHeader, SkStatCards, SkTabsBar, SkFilterBar } from './_primitives';

/** RewardsCatalogPage — 4+ metrics, tabs by category, search+sort+filter, reward cards grid */
const RewardsPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={2} />
    <SkStatCards count={4} />
    <Card className="shadow-sm">
      <SkTabsBar tabs={5} />
      <SkFilterBar filters={3} withButton />
      {/* Reward cards grid: 1 / 2 / 3 / 4 columns */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <Card key={i} className="overflow-hidden" styles={{ body: { padding: 0 } }}>
            <div className="h-40 bg-gray-100">
              <Skeleton.Avatar active size={64} shape="square" />
            </div>
            <div className="p-3">
              <Skeleton active paragraph={{ rows: 2, width: ['90%', '60%'] }} title={false} />
              <div className="flex justify-between items-center pt-2 mt-2">
                <Skeleton.Button active size="small" style={{ width: 70 }} />
                <Skeleton.Button active size="small" style={{ width: 60 }} />
              </div>
            </div>
          </Card>
        ))}
      </div>
    </Card>
  </div>
);

export default RewardsPageLoader;
